export default function trade(state = {}, action) {
    switch (action.type) {
        case "get_symbol_items_success":
            return { ...state, status: 'get_symbol_items_success', symbolItems: action.symbolItems };
        case "get_symbol_items_fail":
            return { ...state, status: 'get_symbol_items_fail', state: action.status };

        case "get_trade_result_success":
            return { ...state, status: "get_trade_result_success", tradeResult: action.tradeResult, symbols: action.symbols };

        case "get_trade_result_fail":
            return { ...state, status: "get_trade_result_fail", state: action.status };

        case "get_get_trade_result_search_success":
            return { ...state, status: 'get_get_trade_result_search_success', tradeResult: action.tradeResult };
        case "get_trade_result_search_fail":
            return { ...state, status: 'get_trade_result_search_fail', state: action.status }

        case "get_remove_trade_success":
            return { ...state, status: "get_remove_trade_success", tradeResult: action.tradeResult, symbols: action.symbols };
        case "get_remove_trade_fail":
            return { ...state, status: "get_remove_trade_fail", state: action.status };

        case "get_general_strategy_result_success":
            return { ...state, status: "get_general_strategy_result_success", items: action.items, tradeDetails: action.tradeDetails };

        case "get_general_strategy_result_fail":
            return { ...state, status: "get_general_strategy_result_fail", state: action.status };

        case "get_general_strategy_result_search_success":
            return { ...state, status: "get_general_strategy_result_search_success", tradeDetails: action.tradeDetails };

        case "get_general_strategy_result_search_fail":
            return { ...state, status: "get_general_strategy_result_search_fail", state: action.status };

        case "get_base_position_success":
            return { ...state, status: 'get_base_position_success', basePosition: action.bp, share: action.share, t: Date.now() };
        case "get_base_position_fail":
            return { ...state, status: 'get_base_position_fail', state: action.status };

        case "get_auth_success":
            return { ...state, status: 'get_auth_success', uri: action.uri, t: Date.now() };
        case "get_auth_failed":
            return { ...state, status: 'get_auth_failed', state: action.status, t: Date.now() };

        case "empty":
            return { ...state, status: '' };
        default:
            return state;
    }
}